import { GzSingleSelectLoadedWebComponent } from './component/GzSingleSelectLoadedWebComponent';

export { GzSingleSelectLoadedWebComponent };
